var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tagType,{tag:"component",staticClass:"cv-list",class:{
    'bx--list--nested': _vm.nested,
    'bx--list--ordered': _vm.internalOrdered,
    'bx--list--unordered': !_vm.internalOrdered,
  },attrs:{"data-nested":_vm.nested}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }